import { get, post, put, httpDelete } from '@/services/infrastructure/api.service'
import type { AccountReconciliation, SaveAccountReconciliationRequest, UpdateAccountReconciliationRequest } from './accountReconciliation'

const path = (accountNo: string) => `/accounts/${accountNo}/reconciliations`

export const listReconciliations = async (accountNo?: string, year?: number): Promise<AccountReconciliation[]> => {
    const url = accountNo ? path(accountNo) : '/accounts/-/reconciliations'
    const result = await get<AccountReconciliation[]>(url, year ? { year } : {})
    return result ?? []
}

export const getReconciliation = async (accountNo: string, uuid: string): Promise<AccountReconciliation | null> => {
    const result = await get<{ content: AccountReconciliation }>(`${path(accountNo)}/${uuid}`)
    return result?.content ?? null
}

export const getReconciliationForPeriod = async (
    accountNo: string, periodType: 'MONTH' | 'YEAR', year: number, month?: number
): Promise<AccountReconciliation | null> => {
    const all = await listReconciliations(accountNo, year)
    return all.find(r =>
        r.periodType === periodType &&
        r.periodYear === year &&
        (periodType === 'YEAR' || r.periodMonth === month)
    ) ?? null
}

export const saveReconciliation = async (accountNo: string, request: SaveAccountReconciliationRequest): Promise<AccountReconciliation | null> => {
    const result: { content: AccountReconciliation } | undefined = await post(path(accountNo), request)
    return result?.content ?? null
}

export const updateReconciliation = async (accountNo: string, uuid: string, request: UpdateAccountReconciliationRequest): Promise<AccountReconciliation | null> => {
    const result: { content: AccountReconciliation } | undefined = await put(`${path(accountNo)}/${uuid}`, request)
    return result?.content ?? null
}

export const deleteReconciliation = async (accountNo: string, uuid: string): Promise<void> => {
    await httpDelete(`${path(accountNo)}/${uuid}`)
}
